<script setup>
import { ref } from 'vue';
import PageLayout from 'dashboard/components-next/layout/PageLayout.vue';
import PageHeader from 'dashboard/components-next/layout/PageHeader.vue';
import SummaryReports from './components/SummaryReports.vue';
import V4Button from 'dashboard/components-next/button/Button.vue';

const summarReportsRef = ref(null);

const onDownloadClick = () => {
  summarReportsRef.value.downloadReports();
};
</script>

<template>
  <PageLayout>
    <template #header>
      <PageHeader
        icon="i-lucide-users-round"
        accent="teal"
        :title="$t('TEAM_REPORTS.HEADER')"
        :subtitle="$t('TEAM_REPORTS.DESCRIPTION')"
      >
        <template #actions>
          <V4Button
            :label="$t('TEAM_REPORTS.DOWNLOAD_TEAM_REPORTS')"
            icon="i-ph-download-simple"
            size="sm"
            @click="onDownloadClick"
          />
        </template>
      </PageHeader>
    </template>

    <SummaryReports
      ref="summarReportsRef"
      action-key="summaryReports/fetchTeamSummaryReports"
      getter-key="teams/getTeams"
      fetch-items-key="teams/get"
      summary-key="summaryReports/getTeamSummaryReports"
      type="team"
    />
  </PageLayout>
</template>
